import { EmbedBlot } from 'parchment';
let Break = /*#__PURE__*/(() => {
  class Break extends EmbedBlot {
    static value() {
      return undefined;
    }
    optimize() {
      if (this.prev || this.next) {
        this.remove();
      }
    }
    length() {
      return 0;
    }
    value() {
      return '';
    }
  }
  Break.blotName = 'break';
  Break.tagName = 'BR';
  return Break;
})();
export default Break;
